module.exports = __webpack_public_path__ + "img/1210-black-mk7.2a01d0fe.png";